<template>
  <div>
    <el-button v-for="(item, index) in c_list" :key="item.id" @click="clickItem(index)">
      <i class="el-icon-picture" style="font-size: 14px; color: #396cf3"></i> {{ item.name }}
    </el-button>
    <el-button v-if="isEdit && list.length < 10" @click="clickItem(-1)" icon="el-icon-circle-plus-outline">添加套图</el-button>

    <EditDialog ref="EditDialogRef"></EditDialog>
    <UseDialog ref="UseDialogRef"></UseDialog>
  </div>
</template>

<script>
import { getGroupPictures } from '@/api/prod/center/index.js';
import EditDialog from './editDialog.vue';
import UseDialog from './useDialog.vue';
import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';

export default {
  components: { EditDialog, UseDialog },
  props: {
    selfForm: {
      type: Object,
      default() {
        return {};
      },
    },
    specifications: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: {
      type: [Number, String],
      default: '',
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    hideImgs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapState({
      groupImages: state => state.mixture.caches.groupImages,
    }),
    c_list({ list, groupImages, baseItemId }) {
      return baseItemId ? list : this.formatList(groupImages);
    },
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async getList() {
      if (!this.baseItemId) return;
      const res = await getGroupPictures({ baseItemId: this.baseItemId });
      this.list = this.formatList(res.data || []);
      this.$emit('getList', this.list)
    },
    formatList(data = []) {
      return data.map(item => {
        return {
          ...item,
          mainImages: item.mainImages ? JSON.parse(item.mainImages) : [],
          mainImages34: item.mainImages34 ? JSON.parse(item.mainImages34) : [],
          detailImages: item.detailImages ? JSON.parse(item.detailImages) : [],
          speImages: item.speImages ? JSON.parse(item.speImages) : [],
          speNames: item.speNames ? JSON.parse(item.speNames) : [],
        };
      });
    },
    clickItem(index) {
      if (this.isEdit) {
        this.$refs.EditDialogRef.method_open({
          specifications: this.specifications,
          selfForm: this.selfForm,
          baseItemId: this.baseItemId,
          list: cloneDeep(this.c_list),
          activeIndex: index,
          okFn: () => {
            this.getList();
          },
        });
      } else {
        this.$refs.UseDialogRef.method_open({
          specifications: this.specifications,
          baseItemId: this.baseItemId,
          list: cloneDeep(this.c_list),
          hideImgs: this.hideImgs,
          activeIndex: index,
          okFn: (data, type) => {
            this.$emit('useOk', data, type)
          },
        });
      }
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
